export const ERROR_CODES = {
  unsuccessfulRecaptcha: 'recaptcha_token_invalid',
  userNotApproved: 'user_is_not_approved',
};
